import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4afbd4b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "setting-main-top" }
const _hoisted_3 = { class: "main_title" }
const _hoisted_4 = { class: "header-left" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow_b",
  src: "/assets/icon/btn_back.png",
  srcset: "/assets/icon/btn_back@2x.png 2x,/assets/icon/btn_back@3x.png 3x"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 설정 ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-margin" }, null, -1))
const _hoisted_8 = { class: "main_content" }
const _hoisted_9 = { class: "content_row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_text" }, " 간편 비밀번호 변경 ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/btn_right_bk.png",
  srcset: "/assets/icon/btn_right_bk@2x.png 2x,/assets/icon/btn_right_bk@3x.png 3x"
}, null, -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_info" }, " 본인인증을 다시 진행한 후 변경이 가능합니다. ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row_text" }, " 개인정보 처리 동의 "),
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/icon/btn_right_bk.png",
    srcset: "/assets/icon/btn_right_bk@2x.png 2x,/assets/icon/btn_right_bk@3x.png 3x"
  })
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_info" }, " 개인정보 처리 동의 및 동의 현황 확인 (카카오클립 등) ", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_row" }, null, -1))
const _hoisted_18 = { class: "gray_content" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_title" }, " 개인정보 설정 ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_text" }, " 이메일 주소 입력 ", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_info" }, " 클럽딜 참여를 위해 이메일 주소를 입력해주세요. ", -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_text" }, " 주소 입력 ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_info" }, " 조합참여 계약을 위해 주소정보가 필요합니다. ", -1))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_text" }, " 은행계좌 입력 ", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_info" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "환불, 배당을 위한 본인 명의"),
  /*#__PURE__*/_createTextVNode(" 은행 계좌를 입력해주세요 ")
], -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_text" }, " 증권계좌 입력 ", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_info" }, [
  /*#__PURE__*/_createTextVNode(" 주식을 받을 수 있는 "),
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "본인 명의"),
  /*#__PURE__*/_createTextVNode(" 증권계좌를 입력해주세요 ")
], -1))
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = { class: "bottom_wrap" }
const _hoisted_33 = { class: "btn_groups space-between" }
const _hoisted_34 = { class: "space-between black" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " · ", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "앱정보 v 2.0.1", -1))
const _hoisted_37 = { class: "delete_wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", {
                    class: "ion-activatable ripple-parent btn-back",
                    onClick: _cache[0] || (_cache[0] = () => {
                  _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'헤더', 'clickContent':'뒤로가기'})
                  _ctx.router.push({ path: '/tabs/mypage'})
                })
                  }, [
                    _hoisted_5,
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ]),
                  _hoisted_6
                ])
              ])
            ]),
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", {
                  class: "row_box",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'상단영역', 'clickContent':'간편비밀번호변경'}); _ctx.$global.openLoginModal()})
                }, _hoisted_12),
                _hoisted_13
              ]),
              _createElementVNode("div", {
                class: "content_row",
                onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'상단영역', 'clickContent':'개인정보처리동의'}); _ctx.$global.openLoginModal()})
              }, _hoisted_16),
              _hoisted_17
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", {
                class: "white_wrap",
                onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'나의정보관리', 'clickContent':'이메일주소입력'}); _ctx.$global.openLoginModal()})
              }, _hoisted_22),
              _createElementVNode("div", {
                class: "white_wrap",
                onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'나의정보관리', 'clickContent':'주소입력'}); _ctx.$global.openLoginModal()})
              }, _hoisted_25),
              _createElementVNode("div", {
                class: "white_wrap",
                onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'나의정보관리', 'clickContent':'은행계좌입력'}); _ctx.$global.openLoginModal()})
              }, _hoisted_28),
              _createElementVNode("div", {
                class: "white_wrap",
                onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'나의정보관리', 'clickContent':'증권계좌입력'}); _ctx.$global.openLoginModal()})
              }, _hoisted_31)
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("button", {
                  class: "common_btn white_btn",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼영역', 'clickContent':'로그인'}); _ctx.$global.openLoginModal()})
                }, " 로그인 "),
                _createElementVNode("button", {
                  class: "common_btn blut_btn",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼영역', 'clickContent':'자주묻는질문'}); _ctx.openFAQModal('FAQ')})
                }, " 자주 묻는 질문 "),
                _createElementVNode("button", {
                  id: "custom-channel-io",
                  class: "common_btn navy_btn custom-channel-io",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼영역', 'clickContent':'1:1문의'}); _ctx.openChannelTalk();})
                }, " 1:1 문의 ")
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", {
                    onClick: _cache[10] || (_cache[10] = ($event: any) => {
                  _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼영역', 'clickContent':'이용약관'});
                  _ctx.openLink('https://www.notion.so/angelleague/03d3a6fa9e0e41bb864d8289720bc52b')})
                  }, "이용약관"),
                  _hoisted_35,
                  _createElementVNode("span", {
                    onClick: _cache[11] || (_cache[11] = ($event: any) => {
                  _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼영역', 'clickContent':'개인정보처리방침'});
                  _ctx.openLink('https://www.notion.so/angelleague/cd4f32d98c4142f0858478c16de78c2f')})
                  }, "개인정보처리방침")
                ]),
                _hoisted_36
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("span", {
                  class: "red",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼영역', 'clickContent':'회원탈퇴'}); _ctx.$global.openLoginModal()})
                }, "회원탈퇴 >")
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}